import {
  LOGISTICS_PT_RESET,
  LOGISTICS_PT_WORKSPACE_LOAD_START,
  LOGISTICS_PT_WORKSPACE_LOAD_SUCCESS,
  LOGISTICS_PT_WORKSPACE_LOAD_ERROR,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  selectedTicketUuid: null,
  ticket: null,
  products: [],
  workspaceLoading: false,
  workspaceError: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOGISTICS_PT_RESET:
      return { ...INIT_STATE };
    case LOGISTICS_PT_WORKSPACE_LOAD_START:
      return {
        ...state,
        workspaceLoading: true,
        workspaceError: null,
        selectedTicketUuid: action.payload?.ticketUuid ?? state.selectedTicketUuid,
      };
    case LOGISTICS_PT_WORKSPACE_LOAD_SUCCESS:
      return {
        ...state,
        workspaceLoading: false,
        workspaceError: null,
        selectedTicketUuid: action.payload?.ticketUuid ?? null,
        ticket: action.payload?.ticket ?? null,
        products: Array.isArray(action.payload?.products) ? action.payload.products : [],
      };
    case LOGISTICS_PT_WORKSPACE_LOAD_ERROR:
      return {
        ...state,
        workspaceLoading: false,
        workspaceError: action.payload ?? "Failed to load ticket workspace",
      };
    default:
      return state;
  }
};
